module.exports = __webpack_public_path__ + "fonts/96726d40e2b17bbcfce28f01d9f5ef18.txt";